import { useEffect, useRef } from 'react';
import styled from 'styled-components';
import LoadingSpinner from '@carvana/loading-spinner';

import type { DatadogSpan } from '../../utilities/dataDog';

const StyledLoadingSpinner = styled(LoadingSpinner)`
  height: 80vh;
`;

type FallbackProps = {
  errorReportTimeout?: number;
  span: DatadogSpan;
};

const Fallback = ({ errorReportTimeout, span }: FallbackProps): JSX.Element => {
  const timeoutReporterId = useRef(0);

  useEffect(() => {
    if (!errorReportTimeout) {
      return () => {};
    }

    timeoutReporterId.current = window.setTimeout(() => {
      span.addErrorEvent('Failure');
    }, errorReportTimeout);

    return () => window.clearTimeout(timeoutReporterId.current);
  }, [errorReportTimeout, span]);

  return <StyledLoadingSpinner isLarge />;
};

export default Fallback;
